"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURATED_STATUS_MAPPING_VALUES = exports.CATEGORY_FROM_FACET_TO_CONSTRUCTOR_GROUP_ID_FILTER = exports.CATEGORY_FROM_FACET_TO_CONSTRUCTOR_FILTER = exports.ARTWORK_CATEGORIES = exports.ARTWORK_STATUS = void 0;
exports.ARTWORK_STATUS = {
    AVAILABLE: 'avail',
    RESERVED: 'reserved',
    SOLD: 'sold',
    UNAVAILABLE: 'unavail',
};
exports.ARTWORK_CATEGORIES = {
    COLLAGE: 'Collage',
    DRAWINGS: 'Drawings',
    DIGITAL: 'Digital',
    INSTALLATION: 'Installation',
    MIXED_MEDIA: 'Mixed Media',
    PAINTINGS: 'Paintings',
    SCULPTURE: 'Sculpture',
    PHOTOGRAPHY: 'Photography',
    PRINTMAKING: 'Printmaking',
};
exports.CATEGORY_FROM_FACET_TO_CONSTRUCTOR_FILTER = {
    ['paintings']: 'painting',
    ['drawings']: 'drawing',
    ['mixed-media']: 'mixed media',
    ['mixed media']: 'mixed media',
};
exports.CATEGORY_FROM_FACET_TO_CONSTRUCTOR_GROUP_ID_FILTER = {
    ['paintings']: 'painting',
    ['drawings']: 'drawing',
    ['mixed-media']: 'mixed-media',
    ['mixed media']: 'mixed-media',
};
exports.CURATED_STATUS_MAPPING_VALUES = {
    ['down']: -1,
    ['not-curated']: 0,
    ['up']: 1,
};
